import { AppState } from '..'

export const SelectUIState = (state: AppState) => state.uiState
